<ca-dropdown-submenu
    *ngIf="isPreviewBtnEnabled || isDownloadBtnEnabled || isShareBtnEnabled || isDeleteBtnEnabled || isRemoveBtnEnabled"
    data-uit="file-submenu"
    (openChange)="openChange.emit($event)"
>
    <button *ngIf="isPreviewBtnEnabled" data-uit="file-preview-btn" type="button" class="dropdown-item" (click)="onPreview()">
        <ca-icon name="eye-open" size="s"></ca-icon>
        {{ 'GENERAL.PREVIEW' | translate }}
    </button>
    <button *ngIf="isShareBtnEnabled" data-uit="file-share-btn" type="button" class="dropdown-item" (click)="openShareViewDialog()">
        <ca-icon name="share" size="s"></ca-icon>
        {{ 'GENERAL.SHARE' | translate }}
    </button>
    <button *ngIf="isDownloadBtnEnabled" data-uit="file-download-btn" type="button" class="dropdown-item" (click)="onDownload()">
        <ca-icon name="download" size="s"></ca-icon>
        {{ 'GENERAL.DOWNLOAD' | translate }}
    </button>
    <button *ngIf="isDeleteBtnEnabled" data-uit="file-delete-btn" type="button" class="dropdown-item" (click)="onDelete()">
        <ca-icon name="trash" size="s"></ca-icon>
        {{ 'GENERAL.DELETE' | translate }}
    </button>
    <button *ngIf="isRemoveBtnEnabled" data-uit="file-remove-btn" type="button" class="dropdown-item" (click)="onRemove()">
        <ca-icon name="cross" size="s"></ca-icon>
        {{ 'GENERAL.REMOVE' | translate }}
    </button>
</ca-dropdown-submenu>
